import type { IconType } from "@airhelp/icons";
import { CaretIcon } from "styles/icons";
import { filterOutLanguages } from "utils/menuUtils";
import type { MenuExtendedProps } from "./menus.d";

export const knowYourRightsMenu: MenuExtendedProps[] = [
  { storyblokId: 71636182, label: "menu_air_passenger_rights" },
  { storyblokId: 71636830, label: "menu_flight_delay_compensation" },
  { storyblokId: 71636192, label: "menu_flight_cancellation_compensation" },
  { storyblokId: 71636184, label: "menu_missed_connection_compensation" },
  {
    storyblokId: 71636186,
    label: "menu_overbooking",
    languages: filterOutLanguages(["pt-pt", "pt-br", "ro", "ro-md", "sv", "fi", "nb", "ru", "el"]),
  },
  { storyblokId: 71636188, label: "menu_denied_boarding_compensation" },
  { storyblokId: 71636187, label: "menu_delayed_baggage_compensation" },
  { page: "airlineStrikeCompensation", label: "menu_airline_strike" },
  { page: "airlines", label: "menu_airlines" },
  { page: "airports", label: "menu_airports", languages: filterOutLanguages(["el", "ru"]) },
  { storyblokId: 71636914, label: "menu_coronavirus" },
];

export const knowYourRightsFooterMenu: MenuExtendedProps[] = knowYourRightsMenu.map((menuItem) => {
  if (menuItem.label === "menu_coronavirus") {
    return {
      storyblokId: 71636208,
      label: "menu_flight_refund",
    };
  }
  return menuItem;
});

export const topMenu: MenuExtendedProps[] = [
  {
    label: "menu_know_your_rights",
    subMenu: knowYourRightsMenu,
    icon: CaretIcon as IconType,
    dataQA: "top-navbar-kyr",
  },
  { storyblokId: 61788293, label: "menu_about_us", attributes: { rel: "nofollow" } },
  {
    storyblokId: 282180211,
    label: "menu_airhelp_plus",
    dataQA: "top-navbar-ah-plus",
    trackingEvent: ["UpperMenu", "AirHelpPlus"],
  },
  {
    storyblokId: 316891649,
    label: "menu_air_payout",
    trackingEvent: ["UpperMenu", "AirPayout"],
  },
  {
    storyblokId: 279912103,
    label: "menu_plan_your_trip",
    trackingEvent: ["UpperMenu", "BookYourTrip"],
    languages: [
      "en",
      "en-au",
      "en-ca",
      "en-gb",
      "en-in",
      "en-int",
      "en-ie",
      "en-nz",
      "de",
      "de-at",
      "de-ch",
      "es",
      "fr",
      "fr-ca",
      "it",
      "pl",
      "pt-br",
      "pt-pt",
      "ro",
      "ro-md",
    ],
  },
];

export const productsMenu: MenuExtendedProps[] = [
  { page: "webappNewClaim", label: "check_your_compensation", attributes: { rel: "nofollow" } },
  { storyblokId: 282180211, label: "menu_airhelp_plus", attributes: { rel: null } },
  { storyblokId: 64335827, label: "menu_refer_a_friend", attributes: { rel: "nofollow" } },
  { storyblokId: 94128112, label: "menu_score" },
  { storyblokId: 71636194, label: "menu_reviews", attributes: { rel: "nofollow" } },
];

export const companyMenu: MenuExtendedProps[] = [
  { storyblokId: 61788293, label: "menu_about_us", attributes: { rel: "nofollow" } },
  { storyblokId: 56747218, label: "menu_blog" },
  { storyblokId: 62392695, label: "menu_press", attributes: { rel: "nofollow" } },
  { page: "careers", label: "menu_careers", attributes: { rel: "nofollow" } },
  { storyblokId: 86291623, label: "menu_affiliate", attributes: { rel: "nofollow" } },
  { storyblokId: 71112922, label: "menu_legal_partners", attributes: { rel: "nofollow" } },
  { storyblokId: 68898974, label: "menu_partners", attributes: { rel: "nofollow" } },
  { storyblokId: 70480540, label: "menu_for_airlines", fallback: "en", attributes: { rel: "nofollow" } },
];

export const supportMenu: MenuExtendedProps[] = [
  { storyblokId: 90578664, label: "menu_help", attributes: { rel: "nofollow" } },
  { storyblokId: 52702007, label: "menu_price_list" },
  { storyblokId: 142848538, label: "our_fees", attributes: { rel: "nofollow" } },
];

export const legalMenu: MenuExtendedProps[] = [
  { storyblokId: 43841167, label: "terms_link_title", attributes: { rel: "nofollow" } },
  { storyblokId: 52663019, label: "terms_privacy_link_title", attributes: { rel: "nofollow" } },
  { storyblokId: 44293804, label: "cookies", attributes: { rel: "nofollow" } },
];

export const imprintMenu: MenuExtendedProps[] = [{ storyblokId: 52883090, label: "menu_imprint" }];
